import * as React from 'react';
import { useState } from "react";
import axios from 'axios';
import Sidebar from '../components/sidebar'
import Footer from '../components/footer'
import Head from '../components/head'
import ReviewForm from './form';

export default function Main() {
  const [name, setName] = useState('')
  const [review, setReview] = useState('')
  const [img, setImg] = useState('')
  const [rating, setRating] = useState(5)
  const [sort, setSort] = useState('0')
  const [status, setStatus] = useState('1')

  const getDb = async () => {
    if (name.trim() === '' || review.trim() === '') {
      alert("Name aur Description dono zaroori hain.")
      return
    }
    const data = new FormData();
    data.append('name', name);
    data.append('review', review);
    data.append('img', img);
    data.append('rating', rating);
    data.append('sort', sort);
    data.append('status', status);
    axios({
      method: 'post',
      url: '/api/review/add.php',
      data: data,
      headers: { 'Content-Type': 'multipart/form-data' },
    })
      .then(s => {
        if (s.data[0].msg === "pass") {
          alert("Review added.")
          setName('')
          setReview('')
          setImg('')
          setRating(5)
          setSort('0')
          setStatus('1')
        } else {
          alert("Not added, try again !")
        }
      })
      .catch(s => {
        console.log('here catch =>>', s);
      });
  };

  return (
    <>
      <div className="main-wrapper">
        <Sidebar />
        <div className="page-wrapper">
          <Head />
          <div>
            <div className="page-content">
              <div className="row">
                <div className="col-md-12 grid-margin stretch-card">
                  <div className="card modern-card">
                    <div className="card-header bg-gradient-primary text-white py-4">
                      <div className="d-flex align-items-center">
                        <div>
                          <h4 className="mb-1">Add New Review</h4>
                          <span className="opacity-75">Website par show hone wala customer review</span>
                        </div>
                      </div>
                    </div>
                    <div className="card-body">
                      <div className="row">
                        <ReviewForm
                          name={name} setName={setName}
                          review={review} setReview={setReview}
                          img={img} setImg={setImg}
                          rating={rating} setRating={setRating}
                          sort={sort} setSort={setSort}
                          status={status} setStatus={setStatus}
                        />
                        <div className="col-lg-12 d-flex justify-content-end mt-4">
                          <button className="btn btn-primary px-4" onClick={() => { getDb(); }}>
                            Save Review
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </>
  )
}
